import React, { FunctionComponent } from "react";
import styled from "styled-components";
import spinner from "../../shared/loaders/img/loading.gif";

const Spinner = styled.img`
  position: absolute;
  right: 10px;
  top: 10px;
  width: 20px;
`;

const FormSubmitting: FunctionComponent<unknown> = () => (
  <>
    <Spinner src={spinner as string} alt="Loading" />
  </>
);

export default FormSubmitting;
